import { InstalmentFreePeriodMonthsDurationRange, PrimaryReasonForIfp } from '@shared/sec-loans'
import { YesNo } from '@ui-common/types'

export const durationInMonthsOptionsOneToSix = ['1', '2', '3', '4', '5', '6'] as const
export const durationInMonthsOptionsSevenToTwelve = ['7', '8', '9', '10', '11', '12'] as const
type DurationInMonthsOneToSix = (typeof durationInMonthsOptionsOneToSix)[number]
type DurationInMonthsSevenToTwelve = (typeof durationInMonthsOptionsSevenToTwelve)[number]

export interface IfpBasicInfoFormData {
  durationInMonthsRange: InstalmentFreePeriodMonthsDurationRange
  durationInMonths: DurationInMonthsOneToSix | DurationInMonthsSevenToTwelve
  startsImmediately: YesNo
  startDate?: string
  primaryReason: PrimaryReasonForIfp
  primaryReasonOther?: string
  hasFinancialDifficulties: YesNo
}
